import { useState } from 'react';
import './App.css';
import globe from './asset/globe.gif'
import axios from 'axios';

function App() {

    const api = "89c903faf4550d25b406884553667849"
    const [data, setData] = useState([{}]);
    const [city, setCity] = useState([]);

    const getWeather = async (event) => {
        if (event.key === "Enter") {
          try {
            const res = await axios.get(`https://api.openweathermap.org/data/2.5/weather?q=${city}&appid=${api}`);
            setData(res.data);
            setCity("");
          } catch (error) {
            console.error(error);
          }
        }
      };
      

    const handleClear = (e) => {
        e.preventDefault()
        setData('undefined')
    }

    return (
        <div className="App flex justify-center items-center w-[100%] h-[990px] bg-[#363636] ">

            <div className="absolute flex justify-center items-center flex-col w-[60%] h-[850px] rounded-[25px] bg-[#A3B6B2] ">
                <input
                    className=" w-[80%] h-[5.5rem] m-0 mt-[5%] z-10 bg-[#D9D9D9] 
                    // placeholder **
                    placeholder:text-center placeholder:text-[2.25rem] placeholder:text-[#363636]
                    // text **
                   text-[2.25rem] text-[#363636]
                    "
                    placeholder="LET'S FIND YOUR PLACE"
                    onChange={event => setCity(event.target.value)}
                    value={city}
                    onKeyPress={getWeather}
                    id='1'
                />
                <div className="Shadow relative right-[1.2%] top-[-18%] w-[80%] h-[5.5rem] m-0 mt-[5%] z-0 bg-[#818181]" />


                <div className='Display-Content w-[100%] h-[70%] mt-[-10%]  text-[#3f3f3f] flex justify-center items-start z-0'>



                    {typeof data.main === 'undefined' ? (

                        // incase : when user not input (HOME PAGE)
                        <div className='flex flex-col justify-start items-center w-[100%] h-[100%] overflow-hidden '>
                            <div className='flex justify-center items-start mt-[-%] w-[100%] h-[100%]'>
                                <img src={globe} alt="globe" className='w-[900px] z-0 absolute' />

                                {data.cod === '404' && (
                                    <p className='text-[white] text-center text-[1.563rem] z-10 relative bg-[rgb(63,63,63,0.6)]'>
                                        Not found. Your place isn't in our data.
                                    </p>
                                )}

                            </div>
                        </div>
                    ) : (
                        <div className='w-[90%] h-[100%] flex flex-row z-0'>

                            {/* The left part */}
                            <div className='TempCard w-[45%] h-[100%] flex justify-end'>
                                <div className='w-[39%] h-[68%] bg-[#D9D9D9] z-10 absolute text-center flex flex-col justify-center items-center'>
                                    <p className='text-[2rem] m-[4%]'>{data.name},{data.sys.country}</p>
                                    <p className='text-[4rem]'>{Math.round(data.main.temp - 273.15)}°C</p>
                                    <p className='text-[2rem]'>{data.weather[0].main}</p>
                                </div>
                                <div className='Shadow w-[95%] h-[95%] bg-[#818181] z-0 relative mt-[5%] mr-[5%]' />
                            </div>

                            {/* The right part */}
                            <div className='FeelLikeCard w-[45%] h-[100%] ml-[2%]'>
                                <div className='w-[39%] h-[68%] bg-[#D9D9D9] z-10 absolute ml-[1%] text-center flex flex-col justify-center items-center'>
                                    <p className='text-[2rem]'>FEELS LIKE</p>
                                    <p className='text-[2rem]'>{Math.round(data.main.feels_like - 273.15)}°C</p>
                                    <p className='UnderLine text-[1rem] m-[5%]'>----------------------</p>
                                    <p className='text-[2rem]'>SKY</p>
                                    <p className='text-[2rem]'>{data.weather[0].description}</p>
                                </div>
                                <div className='Shadow w-[95%] h-[95%] bg-[#818181] z-0 relative mt-[5%] mr-[5%]' />
                            </div>

                            {/* Globe click to go to home page */}
                            <div className='flex absolute bottom-[6%] right-[-2%] items-center justify-center w-[200px] h-[100px] cursor-pointer
                            '
                                onClick={(e) => handleClear(e)}
                            >

                                <img src={globe} alt='globe' className='w-[100%] z-0 relative' />
                                <p className='z-10 text-[1rem] text-white tracking-widest absolute top-10'>CLEAR</p>

                            </div>
                        </div>
                    )}


                </div>

            </div>
        </div >
    );
}

export default App;

